import { createStore } from "vuex";
import {
  getAccessToken,
  setAccessToken,
  clearAuth,
  fetchAndSetUser,
  revokeServerSession,
} from "@/auth";

// Create a new store instance.
export default createStore({
  state() {
    return {
      access_token: getAccessToken(),
      user: null,

      Tplotworks: [],
      TplotworkFlows: [],
      Tplotworkflowsequences: [],
      Tplotworkflowsequencerequestdocuments: [],
      Tplotworkflowsequencenotifications: [],
      Tplotworkflowsequencegenerals: [],
      Tplotworkflowsequenceunits: [],
      Tplotworkflowsequencerequestunits: [],
      Tplotfiles: [],
      TplotSingularTypes: [],
      TplotUnitTypes: [],

      Tbuildingworks: [],
      TbuildingworkFlows: [],
      Tbuildingworkflowsequences: [],
      Tbuildingworkflowsequencerequestdocuments: [],
      Tbuildingworkflowsequencenotifications: [],
      Tbuildingworkflowsequencegenerals: [],
      Tbuildingworkflowsequenceunits: [],
      Tbuildingworkflowsequencerequestunits: [],
      Tbuildingfiles: [],
      TbuildingSingularTypes: [],
      TbuildingUnitTypes: [],

      nodeLocations: [],
    };
  },

  getters: {
    Tplotworks(state) {
      return state.Tplotworks;
    },
    TplotworkFlows(state) {
      return state.TplotworkFlows;
    },
    Tplotworkflowsequences(state) {
      return state.Tplotworkflowsequences;
    },
    Tplotworkflowsequencerequestdocuments(state) {
      return state.Tplotworkflowsequencerequestdocuments;
    },
    Tplotworkflowsequencenotifications(state) {
      return state.Tplotworkflowsequencenotifications;
    },
    Tplotworkflowsequencegenerals(state) {
      return state.Tplotworkflowsequencegenerals;
    },
    Tplotworkflowsequenceunits(state) {
      return state.Tplotworkflowsequenceunits;
    },
    Tplotworkflowsequencerequestunits(state) {
      return state.Tplotworkflowsequencerequestunits;
    },
    Tplotfiles(state) {
      return state.Tplotfiles;
    },
    TplotSingularTypes(state) {
      return state.TplotSingularTypes;
    },
    TplotUnitTypes(state) {
      return state.TplotUnitTypes;
    },

    Tbuildingworks(state) {
      return state.Tbuildingworks;
    },
    TbuildingworkFlows(state) {
      return state.TbuildingworkFlows;
    },
    Tbuildingworkflowsequences(state) {
      return state.Tbuildingworkflowsequences;
    },
    Tbuildingworkflowsequencerequestdocuments(state) {
      return state.Tbuildingworkflowsequencerequestdocuments;
    },
    Tbuildingworkflowsequencenotifications(state) {
      return state.Tbuildingworkflowsequencenotifications;
    },
    Tbuildingworkflowsequencegenerals(state) {
      return state.Tbuildingworkflowsequencegenerals;
    },
    Tbuildingworkflowsequenceunits(state) {
      return state.Tbuildingworkflowsequenceunits;
    },
    Tbuildingworkflowsequencerequestunits(state) {
      return state.Tbuildingworkflowsequencerequestunits;
    },
    Tbuildingfiles(state) {
      return state.Tbuildingfiles;
    },
    TbuildingSingularTypes(state) {
      return state.TbuildingSingularTypes;
    },
    TbuildingUnitTypes(state) {
      return state.TbuildingUnitTypes;
    },
    isAuthenticated(state) {
      return !!state.access_token;
    },
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.access_token = token;
    },
    SET_USER(state, user) {
      state.user = user;
    },
    CLEAR_AUTH(state) {
      state.access_token = null;
      state.user = null;
    },
  },
  actions: {
    /**
     * Token ile giriş yap (JWT URL veya form login sonrası)
     * @param token - Varsa setAccessToken ile kaydedilir, yoksa saveTokens zaten çağrılmıştır.
     */
    async login(store, token) {
      if (token) {
        setAccessToken(token);
      }
      return fetchAndSetUser(store);
    },
    /**
     * Mevcut token ile kullanıcı bilgisini getir
     */
    async fetchAccountInfo(store) {
      return fetchAndSetUser(store);
    },
    logout(store) {
      // Refresh token yerel temizlikten önce okunur; sunucu tarafı oturum kapatma arka planda biter.
      const revoked = revokeServerSession();
      store.commit("CLEAR_AUTH");
      clearAuth();
      return revoked;
    },

    addTplotworks(store, payload) {
      store.state.Tplotworks.push(payload);
    },
    addTplotworkFlows(store, payload) {
      store.state.TplotworkFlows.push(payload);
    },
    addTplotworkflowsequences(store, payload) {
      store.state.Tplotworkflowsequences.push(payload);
    },
    addTplotworkflowsequencegenerals(store, payload) {
      store.state.Tplotworkflowsequencegenerals.push(payload);
    },
    addTplotworkflowsequenceunits(store, payload) {
      store.state.Tplotworkflowsequenceunits.push(payload);
    },
    addTplotworkflowsequencerequestdocuments(store, payload) {
      store.state.Tplotworkflowsequencerequestdocuments.push(payload);
    },
    addTplotworkflowsequencenotification(store, payload) {
      store.state.Tplotworkflowsequencenotifications.push(payload);
    },
    addTplotfiles(store, payload) {
      store.state.Tplotfiles.push(payload);
    },
    addTplotSingularTypes(store, payload) {
      store.state.TplotSingularTypes.push(payload);
    },
    addTplotUnitTypes(store, payload) {
      store.state.TplotUnitTypes.push(payload);
    },
    addTplotworkflowsequencerequestunits(store, payload) {
      store.state.Tplotworkflowsequencerequestunits.push(payload);
    },

    removeTplotworks(store, payload) {
      store.state.Tplotworks = store.state.Tplotworks.filter(
        (t) => t.id != payload.id
      );
    },
    removeTplotworkFlows(store, payload) {
      store.state.TplotworkFlows = store.state.TplotworkFlows.filter(
        (t) => t.id != payload.id
      );
    },
    removeTplotworkflowsequences(store, payload) {
      store.state.Tplotworkflowsequences =
        store.state.Tplotworkflowsequences.filter((t) => t.id != payload.id);
    },
    removeTplotworkflowsequencegenerals(store, payload) {
      store.state.Tplotworkflowsequencegenerals =
        store.state.Tplotworkflowsequencegenerals.filter(
          (t) => t.id != payload.id
        );
    },
    removeTplotworkflowsequenceunits(store, payload) {
      store.state.Tplotworkflowsequenceunits =
        store.state.Tplotworkflowsequenceunits.filter(
          (t) => t.id != payload.id
        );
    },
    removeTplotworkflowsequencerequestdocuments(store, payload) {
      store.state.Tplotworkflowsequencerequestdocuments =
        store.state.Tplotworkflowsequencerequestdocuments.filter(
          (t) => t.id != payload.id
        );
    },
    removeTplotworkflowsequencenotification(store, payload) {
      store.state.Tplotworkflowsequencenotifications =
        store.state.Tplotworkflowsequencenotifications.filter(
          (t) => t.id != payload.id
        );
    },
    removeTplotfiles(store, payload) {
      store.state.Tplotfiles = store.state.Tplotfiles.filter(
        (t) => t.id != payload.id
      );
    },
    removeTplotSingularTypes(store, payload) {
      store.state.TplotSingularTypes = store.state.TplotSingularTypes.filter(
        (t) => t.id != payload.id
      );
    },
    removeTplotUnitTypes(store, payload) {
      store.state.TplotUnitTypes = store.state.TplotUnitTypes.filter(
        (t) => t.id != payload.id
      );
    },
    removeTplotworkflowsequencerequestunits(store, payload) {
      store.state.Tplotworkflowsequencerequestunits =
        store.state.Tplotworkflowsequencerequestunits.filter(
          (t) => t.id != payload.id
        );
    },

    updateTplotworks(store, payload) {
      const index = store.state.Tplotworks.findIndex((t) => t.id == payload.id);
      if (index !== -1) Object.assign(store.state.Tplotworks[index], payload);
    },
    updateTplotworkFlows(store, payload) {
      let state = store.state.TplotworkFlows.find((t) => t.id == payload.id);
      state.name = payload.name;
      state.description = payload.description;
    },
    updateTplotworkflowsequences(store, payload) {
      let state = store.state.Tplotworkflowsequences.find(
        (t) => t.id == payload.id
      );
      state.name = payload.name;
      state.description = payload.description;
      state.flowdescription = payload.flowdescription;
      state.workday = payload.workday;
      state.initializable = payload.initializable;
      state.mainflow = payload.mainflow;
    },
    updateTplotworkflowsequencegenerals(store, payload) {
      store.state.Tplotworkflowsequencegenerals.find(
        (t) => t.id == payload.id
      ).singulartypeId = payload.singulartypeId;
    },
    updateTplotworkflowsequenceunits(store, payload) {
      store.state.Tplotworkflowsequenceunits.find(
        (t) => t.id == payload.id
      ).tplotunittypeId = payload.tplotunittypeId;
    },
    updateTplotworkflowsequencerequestdocuments(store, payload) {
      store.state.Tplotworkflowsequencerequestdocuments.find(
        (t) => t.id == payload.id
      ).tplotfileId = payload.tplotfileId;
    },
    updateTplotworkflowsequencenotification(store, payload) {
      let state = store.state.Tplotworkflowsequencenotifications.find(
        (t) => t.id == payload.id
      );
      state.tplotunittypeId = payload.tplotunittypeId;
      state.singulartypeId = payload.singulartypeId;
      state.description = payload.description;
      state.bitwise = payload.bitwise;
    },
    updateTplotfiles(store, payload) {
      const index = store.state.Tplotfiles.findIndex((t) => t.id == payload.id);
      if (index !== -1) Object.assign(store.state.Tplotfiles[index], payload);
    },
    updateTplotSingularTypes(store, payload) {
      const index = store.state.TplotSingularTypes.findIndex((t) => t.id == payload.id);
      if (index !== -1) Object.assign(store.state.TplotSingularTypes[index], payload);
    },
    updateTplotUnitTypes(store, payload) {
      const index = store.state.TplotUnitTypes.findIndex((t) => t.id == payload.id);
      if (index !== -1) Object.assign(store.state.TplotUnitTypes[index], payload);
    },
    updateTplotworkflowsequencerequestunits(store, payload) {
      let state = store.state.Tplotworkflowsequencerequestunits.find(
        (t) => t.id == payload.id
      );
      state.tplotunittypeId = payload.tplotunittypeId;
    },

    setTplotworks(store, payload) {
      store.state.Tplotworks = payload;
    },
    setTplotworkFlows(store, payload) {
      store.state.TplotworkFlows = payload;
    },
    setTplotworkFlowSequences(store, payload) {
      store.state.Tplotworkflowsequences = payload;
    },
    setTplotworkFlowSequencerequestdocuments(store, payload) {
      store.state.Tplotworkflowsequencerequestdocuments = payload;
    },
    setTplotworkFlowSequencerequestunits(store, payload) {
      store.state.Tplotworkflowsequencerequestunits = payload;
    },
    setTplotworkFlowSequencenotifications(store, payload) {
      store.state.Tplotworkflowsequencenotifications = payload;
    },

    setTplotworkFlowSequencegenerals(store, payload) {
      store.state.Tplotworkflowsequencegenerals = payload;
    },
    setTplotworkFlowSequenceunits(store, payload) {
      store.state.Tplotworkflowsequenceunits = payload;
    },
    setTplotfiles(store, payload) {
      store.state.Tplotfiles = payload;
    },
    setTplotSingularTypes(store, payload) {
      store.state.TplotSingularTypes = payload;
    },
    setTplotUnitTypes(store, payload) {
      store.state.TplotUnitTypes = payload;
    },

    addTbuildingworks(store, payload) {
      store.state.Tbuildingworks.push(payload);
    },
    addTbuildingworkFlows(store, payload) {
      store.state.TbuildingworkFlows.push(payload);
    },
    addTbuildingworkflowsequences(store, payload) {
      store.state.Tbuildingworkflowsequences.push(payload);
    },
    addTbuildingworkflowsequencegenerals(store, payload) {
      store.state.Tbuildingworkflowsequencegenerals.push(payload);
    },
    addTbuildingworkflowsequenceunits(store, payload) {
      store.state.Tbuildingworkflowsequenceunits.push(payload);
    },
    addTbuildingworkflowsequencerequestdocuments(store, payload) {
      store.state.Tbuildingworkflowsequencerequestdocuments.push(payload);
    },
    addTbuildingworkflowsequencenotification(store, payload) {
      store.state.Tbuildingworkflowsequencenotifications.push(payload);
    },
    addTbuildingfiles(store, payload) {
      store.state.Tbuildingfiles.push(payload);
    },
    addTbuildingSingularTypes(store, payload) {
      store.state.TbuildingSingularTypes.push(payload);
    },
    addTbuildingUnitTypes(store, payload) {
      store.state.TbuildingUnitTypes.push(payload);
    },
    addTbuildingworkflowsequencerequestunits(store, payload) {
      store.state.Tbuildingworkflowsequencerequestunits.push(payload);
    },

    removeTbuildingworks(store, payload) {
      store.state.Tbuildingworks = store.state.Tbuildingworks.filter(
        (t) => t.id != payload.id
      );
    },
    removeTbuildingworkFlows(store, payload) {
      store.state.TbuildingworkFlows = store.state.TbuildingworkFlows.filter(
        (t) => t.id != payload.id
      );
    },
    removeTbuildingworkflowsequences(store, payload) {
      store.state.Tbuildingworkflowsequences =
        store.state.Tbuildingworkflowsequences.filter(
          (t) => t.id != payload.id
        );
    },
    removeTbuildingworkflowsequencegenerals(store, payload) {
      store.state.Tbuildingworkflowsequencegenerals =
        store.state.Tbuildingworkflowsequencegenerals.filter(
          (t) => t.id != payload.id
        );
    },
    removeTbuildingworkflowsequenceunits(store, payload) {
      store.state.Tbuildingworkflowsequenceunits =
        store.state.Tbuildingworkflowsequenceunits.filter(
          (t) => t.id != payload.id
        );
    },
    removeTbuildingworkflowsequencerequestdocuments(store, payload) {
      store.state.Tbuildingworkflowsequencerequestdocuments =
        store.state.Tbuildingworkflowsequencerequestdocuments.filter(
          (t) => t.id != payload.id
        );
    },
    removeTbuildingworkflowsequencenotification(store, payload) {
      store.state.Tbuildingworkflowsequencenotifications =
        store.state.Tbuildingworkflowsequencenotifications.filter(
          (t) => t.id != payload.id
        );
    },
    removeTbuildingfiles(store, payload) {
      store.state.Tbuildingfiles = store.state.Tbuildingfiles.filter(
        (t) => t.id != payload.id
      );
    },
    removeTbuildingSingularTypes(store, payload) {
      store.state.TbuildingSingularTypes =
        store.state.TbuildingSingularTypes.filter((t) => t.id != payload.id);
    },
    removeTbuildingUnitTypes(store, payload) {
      store.state.TbuildingUnitTypes = store.state.TbuildingUnitTypes.filter(
        (t) => t.id != payload.id
      );
    },
    removeTbuildingworkflowsequencerequestunits(store, payload) {
      store.state.Tbuildingworkflowsequencerequestunits =
        store.state.Tbuildingworkflowsequencerequestunits.filter(
          (t) => t.id != payload.id
        );
    },

    updateTbuildingworks(store, payload) {
      const index = store.state.Tbuildingworks.findIndex((t) => t.id == payload.id);
      if (index !== -1) Object.assign(store.state.Tbuildingworks[index], payload);
    },
    updateTbuildingworkFlows(store, payload) {
      let state = store.state.TbuildingworkFlows.find(
        (t) => t.id == payload.id
      );
      state.name = payload.name;
      state.description = payload.description;
    },
    updateTbuildingworkflowsequences(store, payload) {
      let state = store.state.Tbuildingworkflowsequences.find(
        (t) => t.id == payload.id
      );
      state.name = payload.name;
      state.description = payload.description;
      state.flowdescription = payload.flowdescription;
      state.workday = payload.workday;
      state.initializable = payload.initializable;
      state.mainflow = payload.mainflow;
    },
    updateTbuildingworkflowsequencegenerals(store, payload) {
      store.state.Tbuildingworkflowsequencegenerals.find(
        (t) => t.id == payload.id
      ).singulartypeId = payload.singulartypeId;
    },
    updateTbuildingworkflowsequenceunits(store, payload) {
      store.state.Tbuildingworkflowsequenceunits.find(
        (t) => t.id == payload.id
      ).TbuildingunittypeId = payload.TbuildingunittypeId;
    },
    updateTbuildingworkflowsequencerequestdocuments(store, payload) {
      store.state.Tbuildingworkflowsequencerequestdocuments.find(
        (t) => t.id == payload.id
      ).TbuildingfileId = payload.TbuildingfileId;
    },
    updateTbuildingworkflowsequencenotification(store, payload) {
      let state = store.state.Tbuildingworkflowsequencenotifications.find(
        (t) => t.id == payload.id
      );
      state.TbuildingunittypeId = payload.TbuildingunittypeId;
      state.singulartypeId = payload.singulartypeId;
      state.description = payload.description;
      state.bitwise = payload.bitwise;
    },
    updateTbuildingfiles(store, payload) {
      const index = store.state.Tbuildingfiles.findIndex((t) => t.id == payload.id);
      if (index !== -1) Object.assign(store.state.Tbuildingfiles[index], payload);
    },
    updateTbuildingSingularTypes(store, payload) {
      const index = store.state.TbuildingSingularTypes.findIndex((t) => t.id == payload.id);
      if (index !== -1) Object.assign(store.state.TbuildingSingularTypes[index], payload);
    },
    updateTbuildingUnitTypes(store, payload) {
      const index = store.state.TbuildingUnitTypes.findIndex((t) => t.id == payload.id);
      if (index !== -1) Object.assign(store.state.TbuildingUnitTypes[index], payload);
    },
    updateTbuildingworkflowsequencerequestunits(store, payload) {
      let state = store.state.Tbuildingworkflowsequencerequestunits.find(
        (t) => t.id == payload.id
      );
      state.TbuildingunittypeId = payload.TbuildingunittypeId;
    },

    setTbuildingworks(store, payload) {
      store.state.Tbuildingworks = payload;
    },
    setTbuildingworkFlows(store, payload) {
      store.state.TbuildingworkFlows = payload;
    },
    setTbuildingworkFlowSequences(store, payload) {
      store.state.Tbuildingworkflowsequences = payload;
    },
    setTbuildingworkFlowSequencerequestdocuments(store, payload) {
      store.state.Tbuildingworkflowsequencerequestdocuments = payload;
    },
    setTbuildingworkFlowSequencerequestunits(store, payload) {
      store.state.Tbuildingworkflowsequencerequestunits = payload;
    },
    setTbuildingworkFlowSequencenotifications(store, payload) {
      store.state.Tbuildingworkflowsequencenotifications = payload;
    },

    setTbuildingworkFlowSequencegenerals(store, payload) {
      store.state.Tbuildingworkflowsequencegenerals = payload;
    },
    setTbuildingworkFlowSequenceunits(store, payload) {
      store.state.Tbuildingworkflowsequenceunits = payload;
    },
    setTbuildingfiles(store, payload) {
      store.state.Tbuildingfiles = payload;
    },
    setTbuildingSingularTypes(store, payload) {
      store.state.TbuildingSingularTypes = payload;
    },
    setTbuildingUnitTypes(store, payload) {
      store.state.TbuildingUnitTypes = payload;
    },
  },
});
